<template>
  <img src="@/../../web/img/system/checked_yes.png" />
</template>

<script>
export default {
  name: 'IconChecked',
}
</script>
